import Menu from './menu.element.js';

export default Menu;

Menu.define('wje-menu', Menu);
